import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserImportResponse, UserProfile, UserCreateDTO } from '../models';
import { Pagination } from '../../pagination';
import { SetUserApplicationRolesDto, User, UserApplicationRoles } from '../../users';
import { MyAccountV2Client } from './my-account-v2.client';
import { MyAccountClient } from './my-account.client';

@Injectable({
  providedIn: 'root',
})
export class UsersApi {
  private readonly basePath = '/users';

  constructor(
    private _http: MyAccountV2Client,
    private _http_old: MyAccountClient,
  ) {}

  fetchProfile(): Observable<UserProfile> {
    return this._http.get(`${this.basePath}/info`);
  }

  updateProfile(userId: string, user: UserCreateDTO): Observable<UserProfile> {
    return this._http.patch(`${this.basePath}/${userId}`, user);
  }

  uploadAvatar(userId: string, image: File): Observable<UserProfile> {
    const formData = new FormData();
    formData.append('file', image);

    return this._http
      .postFormData<{ url: string }>(`${this.basePath}/${userId}/avatar`, formData)
      .pipe(switchMap((response) => this.updateProfile(userId, { avatar: response.url })));
  }

  importUsersByFile(file: File, rolesIds: string[], workspaceId: string, temporaryPassword = true) {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('roles', rolesIds.join(','));
    formData.append('temporary_password', temporaryPassword.toString());

    return this._http_old.postFormData<UserImportResponse>(`/workspaces/${workspaceId}/users/import`, formData);
  }

  getWorkspaceUsers(search: string, workspaceId: string): Observable<Pagination<User>> {
    return this._http.get<Pagination<User>>(`/workspaces/${workspaceId}/users`, { search });
  }

  getUserApplicationRoles(userId: string) {
    return this._http.get<UserApplicationRoles[]>(`/user-roles/${userId}`);
  }

  setUserApplicationRoles(userId: string, roles: SetUserApplicationRolesDto[]) {
    return this._http.patch<UserApplicationRoles[]>(`/user-roles/${userId}`, roles);
  }
}
